import { Component, Output, EventEmitter, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { ModalAcessoRestritoComponent } from '../../saida-gate/modal-acesso-restrito/modal-acesso-restrito.component';
import { ModalEmpresasFaturadasComponent } from '../../saida-gate/modal-empresas-faturadas/modal-empresas-faturadas.component';
import { CaixaService } from 'src/app/services/CaixaService/caixa.service';
import { ICreateCaixa } from 'src/app/services/CaixaService/caixa.model';
import { generateUUID } from 'src/app/core/generators/generateUUID';

@Component({
  selector: 'app-modal-abertura-caixa',
  templateUrl: './modal-abertura-caixa.component.html',
  styleUrls: ['./modal-abertura-caixa.component.scss']
})
export class ModalAberturaCaixaComponent {
  form: FormGroup;
  isLoading: boolean = false;
  guid = generateUUID();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalAcessoRestritoComponent>,
    private fb: FormBuilder,
    private caixaService: CaixaService
  ) {
    this.form = this.initForm();
  }

  initForm() {
    const form = this.fb.group({
      VL_ABTR_CAIX: [0, [Validators.required, Validators.min(0)]]
    });
    return form;
  }

  postAbertura() {
    this.isLoading = true;
    const payload = this.createPayload();
    this.caixaService.CreateCaixa(payload, this.guid).subscribe({
      complete: () => {
        this.isLoading = false;
        this.dialogRef.close();
        location.reload();
      },
      error: err => {
        this.isLoading = false;
        const errorMessage = err.error?.Errors?.Error || err.error?.Error || 'Ocorreu um erro ao abrir o caixa.';
        Swal.fire({
          title: 'Erro!',
          text: errorMessage,
          icon: 'error',
          confirmButtonColor: 'green',
          confirmButtonText: 'Ok'
        });
      }
    });
  }

  createPayload(): ICreateCaixa {
    const raw = this.form.get('VL_ABTR_CAIX')?.value;
    const valor = raw === null || raw === undefined || raw === '' ? 0 : Number(raw);
    return {
      VL_ABTR_CAIX: Number.isFinite(valor) ? valor : 0,
      PermissionToken: this.data.PermissionToken,
      NU_TIPO_CAIX: this.data.NU_TIPO_CAIX != null ? Number(this.data.NU_TIPO_CAIX) : undefined
    };
  }

  onCancelar(): void {
    this.dialogRef.close();
  }
}
